module.exports = __webpack_public_path__ + "static/media/ITUS_black_hand.a866e5ee.svg";